import { styled } from "@stitches/react";
import { Box, FlexBox } from "../primitives";

export const Container = styled(FlexBox, {
  alignItems: "center",
  backgroundColor: "$primary",
  borderBottom: "1px solid #ddd",
  padding: "10px 20px",
  gap: 20,
  justifyContent: "space-between",
  flexWrap: "wrap",
});

export const Item = styled(Box, {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
  fontSize: "10px",
  color: "white",
  gap: 4,
  transition: "color 0.2s ease-in-out",

  "&:hover": {
    color: "#1e90ff",
  },
});
